export default __webpack_public_path__ + "static/media/additional-hunt.3810ba19.png";